import { styled } from "styled-components";

export const ArchStandaloneSectionWrapper = styled.div<{
  $background?: "dark" | "grey";
  $withPadding?: boolean;
}>`
  height: ${({ $withPadding }) => ($withPadding ? "200px" : "100px")};
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 24px;
  position: relative;
  background: ${({ theme, $background }) =>
    $background === "dark"
      ? theme.colors.primary[950]
      : $background === "grey"
        ? theme.colors.default[50]
        : "transparent"};
  @media (min-width: 2400px) {
    height: ${({ $withPadding }) => ($withPadding ? "100px" : "0px")};
  }
`;

export const Arch = styled.div<{ $color: "white" | "grey" | "dark" }>`
  z-index: 0;
  color: ${({ $color, theme }) =>
    $color === "white"
      ? theme.colors.base
      : $color === "dark"
        ? theme.colors.primary[950]
        : theme.colors.default[50]};
  position: absolute;
  bottom: -4px;
  left: 50%;
  transform: translateX(-50%);
  height: 100%;
  width: 110%;
  background: currentColor;
  border-radius: 50% 50% 0 0;
`;

export const VectorWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -80%);
  z-index: 10;
  width: 200px;
  pointer-events: none;

  ${({ theme }) => theme.breakpoints.md.query} {
    top: 30%;
  }
`;
